import { ThermometerPlusIcon } from './ThermometerPlusIcon';

/**
 * author: Michael Richins
 * id 511387A0-FD3A-4335-B82E-9C68E02BABDD
 * name thermometer-plus
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thermometer-plus.svg
 * tags
 * - Home Automation 
 * - Weather 
 */
export const TemperaturePlusIcon = ThermometerPlusIcon;
export default TemperaturePlusIcon